import React from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

const SearchFeedbackPlaceholder = () => {
  return (
    <div className="sui-grid">
      <div data-component="SearchFeedback" data-testid="search-feedback-placeholder-component">
        <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
          <SkeletonBlock aspect="wide" width="100%" />
        </Skeleton>
      </div>
    </div>
  );
};

export { SearchFeedbackPlaceholder };